import { render, staticRenderFns } from "./list_registered_products.vue?vue&type=template&id=6a85a3ab&scoped=true&"
import script from "./list_registered_products.vue?vue&type=script&lang=js&"
export * from "./list_registered_products.vue?vue&type=script&lang=js&"
import style0 from "./list_registered_products.vue?vue&type=style&index=0&id=6a85a3ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85a3ab",
  null
  
)

export default component.exports